import React from "react"
import "react-virtualized/styles.css"
import "./ComplianceTable.scss"
import Loading from "../Loading"
import PropTypes from "prop-types"
import MUIDataTable from "mui-datatables"
import { Progress, Stats } from "@swipesense/shared_components_v2/dist/index"
import { complianceAmount, getBool } from "../../helpers/sharedHelperFunctions"
import { Tv } from "react-bootstrap-icons"

const ComplianceTable = props => {
  const renderRoundingMonitor = (e, unitId) => {
    e.stopPropagation()
    return handleRMRouting(unitId)
  }

  const handleRMRouting = unitId => {
    const path = `unit/${unitId}/roundingMonitor`
    props.updatePath(path)
  }

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "name",
      label: props.nameLabel,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <div>
              <div className="text-caption text-center semi-bold display-inline">
                {value}
              </div>
              <div className="text-caption text-center semi-bold display-inline">
                {/* eslint-disable */}
                {props.subName &&
                  ": " + props.subName(Object.values(props.data)[tableMeta.rowIndex])}
              </div>
            </div>
          )
        },
      },
    },
    {
      name: "compliance",
      label: props.bsrCompliance
        ? "BSR Compliance"
        : "Nurse Rounding Compliance",
      options: {
        filter: true,
        sort: true,
        width: "50%",
        customBodyRender: value => {
          return (
            <div>
              <Progress
                className={complianceAmount(value)}
                percentage={value}
              />
              <div className="text-caption text-center semi-bold display-inline">
                {Math.round(value)}%
              </div>
            </div>
          )
        },
      },
    },
    {
      name: "complianceFirst",
      label: "1st Shift Change",
      options: {
        filter: props.bsrCompliance,
        sort: true,
        display: props.bsrCompliance,
        viewColumns: props.bsrCompliance,
        customBodyRender: value => {
          return (
            <div>
              <Progress
                className={complianceAmount(value)}
                percentage={value}
              />
              <div className="text-caption text-center semi-bold display-inline">
                {Math.round(value)}%
              </div>
            </div>
          )
        },
      },
    },
    {
      name: "complianceSecond",
      label: "2nd Shift Change",
      options: {
        filter: props.bsrCompliance,
        sort: true,
        display: props.bsrCompliance,
        viewColumns: props.bsrCompliance,
        customBodyRender: value => {
          return (
            <div>
              <Progress
                className={complianceAmount(value)}
                percentage={value}
              />
              <div className="text-caption text-center semi-bold display-inline">
                {Math.round(value)}%
              </div>
            </div>
          )
        },
      },
    },
    {
      name: "change",
      label: "Overall Change",
      options: {
        filter: true,
        sort: true,
        customBodyRender: value => {
          return (
            <div>
              <Stats
                percent={Math.round(value)}
                increaseOccurrence={getBool(value)}
              />
            </div>
          )
        },
      },
    },
    {
      name: "opportunities",
      label: "Overall Opportunities",
      options: {
        filter: true,
        sort: true,
        customBodyRender: value => {
          return (
            <div className="opportunities-container text-caption text-center semi-bold">
              {value}
            </div>
          )
        },
      },
    },
    {
      name: "rounding monitor",
      label: "Rounding Monitor",
      options: {
        filter: props.nameLabel === "Unit",
        sort: true,
        display: props.nameLabel === "Unit" && !props.bsrCompliance && process.env.NODE_ENV !== "production",
        customBodyRender: (value, meta) => {
          const unitId = meta.rowData[0]

          return (
            <div className="text-caption text-center semi-bold">
              <Tv
                onClick={(event) => renderRoundingMonitor(event, unitId)}
                className="rounding-icon">
              </Tv>
            </div>
          )
        },
      },
    },
  ]

  const data = props.data

  if (props.loading) {
    return <Loading />
  } else {
    return (
      <MUIDataTable
        title={props.nameLabel + " Table"}
        data={data}
        columns={columns}
        options={{
          onRowClick: props.onRowClick,
          selectableRows: false,
          textLabels: {
            body: {
              noMatch: "No data found. Try a new search or date range.",
            }
          }
        }}
        filterOptions={{
          useDisplayedRowsOnly: true,
        }}
      />
    )
  }
}

ComplianceTable.propTypes = {
  loading: PropTypes.bool,
  bsrCompliance: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      compliance: PropTypes.number,
      change: PropTypes.number,
      opportunities: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  subName: PropTypes.func,
}

ComplianceTable.defaultProps = {
  bsrCompliance: false,
}

export default ComplianceTable
